import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { AppConfigService } from '@core/appconfig.service';

@Component({
  selector: 'zbp-no-license',
  templateUrl: './no-license.component.html',
  styleUrls: ['./no-license.component.scss'],
  standalone: false
})
export class NoLicenseComponent implements OnInit  {
  navigateBack: boolean;
  isHighlightsPortal: boolean|null = null;


  /**
   * Currently used by Districts and School Routing Module for '/expired' routes.
   */
  constructor(
    private route: ActivatedRoute,
    private appConfig: AppConfigService,
    private title: Title,
  ) { }

  ngOnInit() {
    this.isHighlightsPortal = this.appConfig.isHighlightsPortalUrl;
    this.route.queryParams
      ?.subscribe((params: Params) => {
        this.navigateBack = params['navigateBack'] === 'true';
      });

    const siteName = this.appConfig.getBrandTitle;
    this.title.setTitle(`Subscription Expired | ${siteName}`);
  }
}
